'use client';

import { defaultProps } from "../Link.defaultProps.js";
import { emphasis } from "../Link.css.js";
function getEmphasisClassName({
  emphasis: emphasisProp,
  onDark
}) {
  const emphasis$1 = emphasisProp || defaultProps.emphasis;
  const surface = onDark ? "onDark" : "onLight";
  return emphasis[emphasis$1][surface];
}
export {
  getEmphasisClassName
};
